import dayjs from "dayjs"
import React, { useEffect } from "react"
import styled from "styled-components"
import { dayOfBirth, monthOfBirth, yearOfBirth } from "~/utils/functions"
import AcIcon from "./AcIcon"

type Props = {
  name: string
  value?: string
  isConfirm?: boolean
  disabled?: boolean
  onChange?: (params: string) => any | null
}

function AcBirthdayInput(props: Props) {
  const { onChange, isConfirm, disabled, value = "2000-1-1" } = props

  const date = {
    day: dayjs(value).get("D"),
    month: dayjs(value).get("M") + 1,
    year: dayjs(value).get("year"),
  }

  const onChangeValue = (e) => {
    const newDate = { ...date, [e.target.name]: Number(e.target.value) }

    const amountDate = dayjs(`${newDate.year}-${newDate.month}`).daysInMonth()

    onChange(`${newDate.year}-${newDate.month}-${newDate.day <= amountDate ? newDate.day : 1}`)
  }

  useEffect(() => {
    onChange(value)
  }, [])

  return (
    <Content>
      {isConfirm ? (
        `${dayjs(value).format("YYYY年　MM月　DD日")}`
      ) : (
        <>
          <SelectContainer year>
            <SelectContent>
              <Select
                disabled={disabled}
                onChange={onChangeValue}
                year
                defaultValue={2000}
                value={date.year}
                name="year"
              >
                {yearOfBirth().map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
              <AcIcon name="chevron-down" className="arrow-icon" />
            </SelectContent>
            <div className="label">年</div>
          </SelectContainer>
          <SelectContainer>
            <SelectContent>
              <Select
                disabled={disabled}
                value={date.month}
                onChange={onChangeValue}
                name="month"
                defaultValue={1}
              >
                {monthOfBirth().map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
              <AcIcon name="chevron-down" className="arrow-icon" />
            </SelectContent>
            <div className="label">月</div>
          </SelectContainer>
          <SelectContainer>
            <SelectContent>
              <Select
                disabled={disabled}
                value={date.day}
                onChange={onChangeValue}
                defaultValue={3}
                name="day"
              >
                {dayOfBirth(`${date.year}-${date.month}`).map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
              <AcIcon name="chevron-down" className="arrow-icon" />
            </SelectContent>
            <div className="label">日</div>
          </SelectContainer>
        </>
      )}
    </Content>
  )
}

export default AcBirthdayInput

const SelectContent = styled.div`
  margin-right: 10px;

  position: relative;
  flex-grow: 1;
  .arrow-icon {
    position: absolute;
    top: 9px;
    right: 5px;
    font-size: 0.9em;
  }
`

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: ${(props) => (props.year ? "40%" : "30%")};
`
const Content = styled.div`
  display: flex;
`

const Select = styled.select`
  &:disabled {
    background-color: #e6e6e6 !important;
  }
  font-size: 16px;
  display: block;
  width: 100%;
  border: 1px solid #bdbfc8;
  padding: 13px 10px;
  border-radius: 4px;
  background-color: #ffffff;
`
